import { decode as base64Decode } from 'base-64';

/**
 * Extract device UUID from JWT token
 * @param {string} token - JWT token
 * @returns {string|null} - Device UUID or null if extraction fails
 */
export const extractDeviceUuidFromToken = (token) => {
    try {
        const parts = token.split('.');
        if (parts.length !== 3) return null;
        
        const payload = parts[1];
        const paddedPayload = payload + '='.repeat((4 - payload.length % 4) % 4);
        const decodedPayload = base64Decode(paddedPayload);
        const parsedPayload = JSON.parse(decodedPayload);

        // Extract UUID from token data (similar to device_id extraction)
        const data = JSON.parse(parsedPayload?.data?.data || '{}');
        return data.device_uuid || parsedPayload.device_uuid || null;
    } catch (error) {
        console.error('Error extracting device UUID from token:', error);
        return null;
    }
};
